<template>
  <div class="w-full px-4 my-3">
    <div class="text-sm">
      <div
        class="flex cursor-pointer"
        :class="{
          'bg-primary-400 hover:bg-primary-300 text-white dark:bg-dark-400 dark:hover:bg-dark-300 rounded-top dark:text-dark-text':
            reviewPostPageStatePresenter.isSummaryExpanded(entryId).value,
          'rounded-all hover:bg-gray-100 dark:hover:bg-dark-500':
            !reviewPostPageStatePresenter.isSummaryExpanded(entryId).value
        }"
        @click="clickEntrySummary(entryId)"
      >
        <span
          v-if="reviewPostPageStatePresenter.isSummaryExpanded(entryId).value"
          class="material-icons pr-2 h-full my-auto w-12"
          style="padding-left: 14px"
        >
          arrow_drop_up
        </span>
        <span v-else class="material-icons pr-2 h-full my-auto w-12" style="padding-left: 14px"> arrow_drop_down </span>
        <div class="w-full grid grid-cols-6">
          <div class="pl-4 pr-2 py-3">
            {{ entry.judgeId }}
          </div>
          <div class="px-2 py-3">{{ entry.userId }}</div>
          <div class="items-center justify-center px-2 py-2" style="padding-top: 10px">
            <JudgeBadge :status="entry.status" />
          </div>
          <div class="px-2 py-3">{{ entry.language }}</div>
          <div class="px-2 py-3 col-span-2">
            {{ timestampToDate(entry.entryDate) }}
          </div>
        </div>
      </div>
      <div
        v-if="isLoading"
        class="border shadow-md flex justify-center items-center border-primary-50 dark:border-dark-400"
        style="height: 120px; border-bottom-left-radius: 0.5rem; border-bottom-right-radius: 0.5rem"
      >
        <LoadingPanel />
      </div>
      <div
        v-show="!isLoading"
        :class="{
          'rounded-bottom border shadow-md border-primary-50 dark:border-dark-400':
            reviewPostPageStatePresenter.isSummaryExpanded(entryId).value
        }"
      >
        <Transition name="slide-fade">
          <div v-show="reviewPostPageStatePresenter.isSummaryExpanded(entryId).value">
            <div v-if="!hasEntryDetailInList(entryId)" class="px-4 py-3">
              {{ $t('message.noData') }}
            </div>
            <div v-else class="w-full flex">
              <div class="w-full">
                <div
                  v-for="(detail, detailIndex) in reviewEntryDetailList[entryId]"
                  :key="detailIndex"
                  @click="reviewPostPageStatePresenter.setEntrySelectedReviewIndex(entryId, detailIndex)"
                >
                  <!--短縮状態-->
                  <Transition name="left-slide-fade">
                    <div
                      v-if="
                        reviewPostPageStatePresenter.isDetailSelected(entryId).value ||
                        reviewPostPageStatePresenter.entryEditingList.value[entryId]
                      "
                      class="flex cursor-pointer my-3 ml-3"
                      :class="{
                        'bg-primary-50 dark:bg-dark-400':
                          reviewPostPageStatePresenter.entrySelectedReviewIndexList.value[entryId] === detailIndex,
                        'hover:bg-gray-100 dark:hover:bg-dark-500':
                          reviewPostPageStatePresenter.entrySelectedReviewIndexList.value[entryId] !== detailIndex
                      }"
                      style="border-radius: 0.5rem"
                      :style="{ '--delay': `${detailIndex * 100 + 100}ms` }"
                    >
                      <span class="material-icons text-sm pr-2 my-auto py-3 w-12" style="padding-left: 18px">
                        subdirectory_arrow_right
                      </span>
                      <div>
                        <div class="px-2 py-3">{{ detail.reviewerId }}</div>
                      </div>
                    </div>
                  </Transition>
                  <!--横長状態-->
                  <Transition name="left-slide-fade">
                    <div
                      v-if="
                        !reviewPostPageStatePresenter.isDetailSelected(entryId).value &&
                        !reviewPostPageStatePresenter.entryEditingList.value[entryId]
                      "
                      class="flex cursor-pointer my-3 mx-2 hover:bg-gray-100 dark:hover:bg-dark-500"
                      style="border-radius: 0.5rem"
                      :style="{ '--delay': `${detailIndex * 100 + 100}ms` }"
                    >
                      <span class="material-icons text-sm pr-2 py-3 w-12" style="padding-left: 18px">
                        subdirectory_arrow_right
                      </span>
                      <div class="w-full grid grid-cols-5">
                        <div class="px-2 py-3">{{ detail.reviewerId }}</div>
                        <div />
                        <div />
                        <div class="px-2 py-3 col-span-2">
                          {{ timestampToDate(detail.reviewDate as any) }}
                        </div>
                      </div>
                    </div>
                  </Transition>
                </div>
                <!--新規投稿-->
                <div
                  class="my-3 ml-3 flex items-start justify-start"
                  :class="{
                    'mx-2':
                      !reviewPostPageStatePresenter.isDetailSelected(entryId).value &&
                      !reviewPostPageStatePresenter.entryEditingList.value[entryId],
                    'bg-primary-50 dark:bg-dark-400': reviewPostPageStatePresenter.entryEditingList.value[entryId],
                    'hover:bg-gray-100 dark:hover:bg-dark-500':
                      !reviewPostPageStatePresenter.entryEditingList.value[entryId]
                  }"
                  style="border-radius: 0.5rem"
                >
                  <button
                    class="w-full flex items-start justify-start focus:outline-none"
                    @click="reviewPostPageStatePresenter.reverseEntryEditingFlag(entryId)"
                  >
                    <span class="material-icons py-3 pl-4">add_circle</span>
                    <div class="px-2 my-auto">{{ $t('message.newReviewSubmit') }}</div>
                  </button>
                </div>
              </div>
              <Transition name="left-slide-fade">
                <div
                  v-if="
                    reviewPostPageStatePresenter.isDetailSelected(entryId).value ||
                    reviewPostPageStatePresenter.entryEditingList.value[entryId]
                  "
                  style="width: 240%"
                >
                  <ReviewEditorPanel
                    v-if="reviewPostPageStatePresenter.entryEditingList.value[entryId]"
                    :entry="entry"
                    :entryId="entryId"
                    :isDarkMode="{}"
                  />
                  <ReviewDetailPanel :entryId="entryId" :entryType="entryType" :index="index" />
                </div>
              </Transition>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import ReviewEditorPanel from './ReviewEditorPanel.vue'

import LoadingPanel from '@/presentation/components/Loading/LoadingPanel.vue'
import ReviewDetailPanel from '@/presentation/components/ReviewPost/children/ReviewDetailPanel.vue'
import JudgeBadge from '@/presentation/components/Text/JudgeBadge.vue'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useReviewPostPageStatePresenter } from '@/presentation/composables/reviewPost/useReviewPageStatePresenter'
import { useReviewPostEntryDetailPresenter } from '@/presentation/composables/reviewPost/useReviewPostEntryDetailPresenter'
import { useReviewPostPresenter } from '@/presentation/composables/reviewPost/useReviewPostPresenter'
import timestampToDate from '@/util/date/timestampToDate'

export default defineComponent({
  components: { JudgeBadge, LoadingPanel, ReviewDetailPanel, ReviewEditorPanel },
  props: {
    entry: {
      type: Object,
      required: true
    },
    entryType: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    length: {
      type: Number,
      required: true
    }
  },
  setup(props, _) {
    const { isLightMode } = useConfigStatePresenter()
    const { isLoading, clickEntrySummary } = useReviewPostPresenter()
    const reviewPostPageStatePresenter = useReviewPostPageStatePresenter()
    const { reviewEntryDetailList, hasEntryDetailInList } = useReviewPostEntryDetailPresenter()

    const entryId = props.entry.entryId

    return {
      timestampToDate,
      isLightMode,
      entryId,
      clickEntrySummary,
      reviewPostPageStatePresenter,
      reviewEntryDetailList,
      isLoading,
      hasEntryDetailInList
    }
  }
})
</script>

<style lang="postcss" scoped>
.slide-fade-enter-active {
  transition: all 0.4s ease-out;
  overflow: hidden;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-in;
  overflow: hidden;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-32px);
  opacity: 0;
}

.left-slide-fade-enter-active {
  transition: all 0.2s ease-in;
  overflow: hidden;
  transition-delay: var(--delay, 0ms);
}

.left-slide-fade-enter-from,
.left-slide-fade-leave-to {
  transform: translateX(-32px);
  opacity: 0;
}

.rounded-all {
  border-radius: 0.5rem;
}

.rounded-top {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}

.rounded-bottom {
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
</style>
